<mat-card appearance="outlined" class="flex-item flex-1 flex-layout column start-center">
	<mat-card-header class="flex-layout column">
		<mat-icon class="logo flex-item" svgIcon="logo"></mat-icon>
		<mat-card-title class="flex-item"
			><h2>{{ (items$ | async)?.change_password.title | translate }}</h2></mat-card-title
		>
	</mat-card-header>
	<mat-card-content>
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<mat-form-field
				hideRequiredMarker
				[class.password-field-error-gup]="
					passwordErrorCount > 2 && this.form.controls.password.touched
				"
			>
				<input
					#newPassword
					autocomplete="new_password"
					autofocus
					type="password"
					matInput
					placeholder="{{ (items$ | async)?.change_password.new_password | translate }}"
					formControlName="password"
				/>
				<mat-icon
					class="pointer"
					(click)="toggleInputType($event, newPassword)"
					matSuffix
					[svgIcon]="getInputIcon(newPassword.type)"
				></mat-icon>
				<mat-error>
					@if (
						(this.form.controls.password.touched && checkError('length')) ||
						checkError('uppercase') ||
						checkError('lowercase') ||
						checkError('number')
					) {
						<span>
							{{ 'validation_password_must_contain' | translate }}
						</span>
					}
					@if (checkError('length')) {
						<span class="error-info">{{
							'validation_password_min_length' | translate
						}}</span>
					}
					@if (checkError('uppercase')) {
						<span class="error-info">{{
							'validation_password_uppercase' | translate
						}}</span>
					}
					@if (checkError('lowercase')) {
						<span class="error-info">{{
							'validation_password_lowercase' | translate
						}}</span>
					}
					@if (checkError('number')) {
						<span class="error-info">{{ 'validation_password_number' | translate }}</span>
					}
				</mat-error>
			</mat-form-field>

			<mat-form-field hideRequiredMarker>
				<input
					#passwordRepeat
					autocomplete="new_password_repeat"
					type="password"
					matInput
					placeholder="{{
						(items$ | async)?.change_password.repeat_password | translate
					}}"
					formControlName="confirmPassword"
					[errorStateMatcher]="errorMatcher"
				/>
				<mat-icon
					class="pointer"
					(click)="toggleInputType($event, passwordRepeat)"
					matSuffix
					[svgIcon]="getInputIcon(passwordRepeat.type)"
				></mat-icon>
				<mat-error>
					@if (form.errors) {
						<span>{{ 'validation_passwords_mismatch' | translate }}</span>
					}
				</mat-error>
			</mat-form-field>

			<button mat-raised-button color="primary" type="submit" mat-button>
				{{ (items$ | async)?.change_password.button | translate | titlecase }}
			</button>
		</form>
	</mat-card-content>
</mat-card>
